import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import { reportPublicError } from '@/observability/publicTelemetry';
import { CustomerLocationProvider } from '@/features/location/useCustomerLocation';
import { CartExpiryGuard } from '@/features/cart/CartExpiryGuard';

export function AppProviders({ children }: PropsWithChildren) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({ onError: (error) => reportPublicError(error, 'query') }),
        mutationCache: new MutationCache({
          onError: (error) => reportPublicError(error, 'mutation'),
        }),
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
          mutations: { retry: false },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <CartExpiryGuard />
      <CustomerLocationProvider>{children}</CustomerLocationProvider>
    </QueryClientProvider>
  );
}
